import React, {  Component } from 'react';

export default class RequestReturnApprovalDialog extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showDialog: false
        }
    }

    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
		this.props.handleDialog && this.props.handleDialog('RequestReturnApprovalDialog', false);
    }

    componentDidMount() {
		// window.scrollTo(0, 0);
        this.setState({
            showDialog: this.props.showDialog
        });
    }

    render() {
        return (
            <div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="actionDescriptionsOverlayDialog">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
                    <a className="closeButton" onClick={this.closeDialog.bind(this)}>×</a>
                    <h2 className="title">WARNING</h2>
                    <p className="bold red" style={{ marginTop: '1px', textTransform:"uppercase"}}>
                        Out of policy returns require RM approval. Please confirm approval above and enter the approver's name.</p>
            	</div>
			</div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/App/components/dialogs/requestReturnApprovalDialog.js